// extracted by mini-css-extract-plugin
module.exports = {"controls":"_3Kix7UTN6-bIbjUhj_2CEI","progress":"LT0sJA71qSKEvREH3gstO","value":"_3DLyVAkujp6HE1Bfn3En-_","btn":"_1wn_fbPtVcKQh4ltsI-xiO"};